import styled from 'styled-components';
import DocsTask from './DocsTask';

export default styled(DocsTask)`
  .docs-task {
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    margin: 1rem 1.5rem;

    &__header {
      background: var(--grey300);
      display: flex;
      min-height: 2.4rem;
      padding: 0.3rem 1rem;
    }

    &__title {
      flex: 1;
    }

    &__owner {
      color: var(--primary500);
    }

    &__body {
      background: var(--white);
      display: flex;
      justify-content: space-between;
      padding: 1rem;
    }
  }
`;
